import { useLocation } from 'react-router';

export const useFooter = () => {
  const { pathname } = useLocation();

  const isProductPage = pathname.includes('/product/') && !pathname.includes('/quotation');

  return { isProductPage };
};
